module.exports = __webpack_public_path__ + "static/media/delete.ff67fe8e.svg";